import module from 'nominas/nomina/module.js'
import template from './template.html'

const generarLeyenda = (secciones) => secciones
  .filter(([pagos]) => pagos > 0)
  .reduce((leyenda, [pagos, singular, plural], indice, secciones) => leyenda
    + (indice > 0 ? ((indice + 1) < secciones.length ? ', ' : ' y ') : '')
    + `${pagos + (indice === 0 ? ` pago${pagos === 1 ? '' : 's'}` : '')} ${pagos === 1 ? singular : plural}`
    , '')

export class NominasNominaDispersionPagosTransferenciasComponent {
  admin
  data
  editando = false
  leyenda = ''

  $onChanges (changes) {
    if (changes.data) {
      this.data = {...this.data}
      this.actualizarLeyenda()
    }
  }

  actualizar (data) {
    this.data.pagos_retenidos = data.filter((item) => (!item.status_aprobado || !item.activo) && !item.status_pagado && !item.pendiente).length
    this.data.pagos_pendientes = data.filter((item) => item.status_aprobado && item.activo && !item.status_pagado && !item.pendiente).length
    this.data.pagos_en_proceso = data.filter((item) => !item.status_pagado && item.pendiente).length
    this.data.pagos_completados = data.filter((item) => item.status_pagado && !item.pendiente).length
    this.data.completado = (this.data.pagos_retenidos + this.data.pagos_pendientes + this.data.pagos_en_proceso) === 0
    this.actualizarLeyenda()
  }

  actualizarLeyenda () {
    if (this.data.completado) {
      this.leyenda = this.data.pagos_completados + (this.data.pagos_completados > 1 ? ' pagos' : ' pago')
    } else {
      this.leyenda = generarLeyenda([
        [this.data.pagos_retenidos, 'retenido', 'retenidos'],
        [this.data.pagos_pendientes, 'pendiente', 'pendientes'],
        [this.data.pagos_en_proceso, 'en proceso', 'en proceso'],
        [this.data.pagos_completados, 'completado', 'completados'],
      ])
    }
  }
}

module.component('nominasNominaDispersionPagosTransferencias', {
  controller: NominasNominaDispersionPagosTransferenciasComponent,
  template,
  bindings: {
    admin: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/dispersion/pagos/transferencias/component.js